import React from 'react';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import DashboardComp from '../../containers/PartnerKyc/Dashboard/Dashboard';
import { obj } from '../../common/userData/UserKycStatus';

const kyc = () => {
  obj.isFirstLoadKYC = true;
  return (
    <div className="dashboard">
      <Helmet title={`Partner KYC | ${siteTitle}`} />
      <DashboardComp />
    </div>
  );
};

export default kyc;
